import classNames from "classnames";
import { HtmlEditorHeader } from "./HtmlEditorHeader";
import { AgentChat } from "./AgentChat";
import { EditorMessageSanding } from "./AgentChat/EditorMessageSanding";
import { useEditorChat } from "../../hook/use-editor-chat";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { CleanSpaChatModal } from "../CleanSpaChatModal";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const HtmlEditor = () => {
  const {
    message,
    isFileLoading,
    fileName,
    handleClick,
    handleClearChat,
    handleUploadHtml,
    handleDeleteFileTag,
    handleFileUpload,
    handleChangeMessage,
    handleSendKeyDown,
    handleSendMessage,
  } = useEditorChat();
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const { selectedObject } = useStorageSelectors("ai_agents_spa");

  return (
    <div
      className={classNames(
        styles["editor-wrapper"],
        !selectedObject?.write && styles["disabled"],
      )}
    >
      <HtmlEditorHeader handleClearChat={() => {}} />
      <div className={classNames(styles["code-container"])}>
        <AgentChat />
      </div>
      <EditorMessageSanding
        sendValue={message}
        fileName={fileName ?? null}
        isFileLoading={isFileLoading}
        handleClick={handleClick}
        handleUploadHtml={handleUploadHtml}
        handleFileUpload={handleFileUpload}
        handleDeleteFileTag={handleDeleteFileTag}
        handleKeyDown={handleSendKeyDown}
        sendMessage={handleSendMessage}
        clearChat={() => handleOpenModal("clean_spa_chat_modal", null)}
        onChange={handleChangeMessage}
      />
      <CleanSpaChatModal
        closeModal={handleCloseModal}
        handleCleanChat={handleClearChat}
      />
    </div>
  );
};
